import type { Capability } from '~/graphql/generated/graphql';

import { adminRoleFragment } from '~/graphql/documents/core';
import { useFragment } from '~/graphql/generated/fragment-masking';

export const useCapabilities = () => {
  const authStore = useAuthStore();

  const user = computed(() => authStore.user);

  const adminRoles = computed(() => {
    if (!user.value) {
      return [];
    }

    return user.value.adminRoles.map(r => useFragment(adminRoleFragment, r));
  });

  const capabilities = computed<Capability[]>(() => {
    return [...new Set(adminRoles.value.flatMap(role => role.capabilities))];
  });

  const can = (capability: Capability) => capabilities.value.includes(capability);

  const canAll = (required: Capability[]) => required.every(capability => can(capability));

  return {
    capabilities,
    can,
    canAll,
  };
};
